import { createSlice } from '@reduxjs/toolkit';
import deletePrevImage from '@custom/rtk-apis/report/deletePreviewImage'

const initialState = {
  status: "",
  result: null,
  msg: "",
  loading: false,
};

const deletePrevImgSlice = createSlice({
  name: 'deletePrevImgSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deletePrevImage.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePrevImage.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(deletePrevImage.rejected, (state, { error }) => {
        state.loading = false;
        state.status = 'ERROR';
        state.msg = error.message;
      });
  },
});

export default deletePrevImgSlice.reducer;
